/* UNIT — Fiche produit : galerie, visionneuse, pastilles couleur -> tunnel, barre flottante, parallaxe.
   La logique du tunnel (boms-unit-funnel) n'est pas modifiée : on clique simplement sur son bouton de départ. */
(function () {
  'use strict';
  if (window.__uPdp) return;
  window.__uPdp = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ').trim(); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  /* ---------- ouverture du tunnel ---------- */
  function openFunnel(color) {
    var start = document.getElementById('unit-sales-funnel-startbtn');
    if (!start) return;
    if (color) {
      try {
        var want = norm(color);
        var radios = $$('#unit-sales-funnel-step-3 input[type="radio"]');
        var hit = radios.filter(function (r) { return norm(r.value) === want; })[0] ||
                  radios.filter(function (r) { return norm(r.value).indexOf(want) === 0; })[0];
        if (hit && !hit.checked) {
          hit.checked = true;
          hit.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } catch (e) {}
    }
    start.click();
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-u-funnel]');
    if (!t) return;
    e.preventDefault();
    openFunnel(t.getAttribute('data-color') || '');
  });

  /* ---------- galerie ---------- */
  var lb = null, lbKey = null, lastFocus = null;
  function closeLB() {
    if (!lb) return;
    var node = lb; lb = null;
    document.removeEventListener('keydown', lbKey);
    node.classList.remove('in');
    document.body.classList.remove('u-lb-open');
    setTimeout(function () { if (node.parentNode) node.parentNode.removeChild(node); }, 350);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }
  function openLB(pics, start, alt) {
    closeLB();
    lastFocus = document.activeElement;
    var idx = start || 0;
    lb = document.createElement('div');
    lb.className = 'u-lb';
    lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.setAttribute('aria-label', alt || 'Photo');
    var fig = document.createElement('figure');
    var img = document.createElement('img'); img.alt = alt || '';
    fig.appendChild(img); lb.appendChild(fig);
    function show(n) { idx = (n + pics.length) % pics.length; img.src = pics[idx]; }
    var X = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg>';
    var PREV = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 6-6 6 6 6"/></svg>';
    var NEXT = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 6 6 6-6 6"/></svg>';
    function btn(cls, label, html, fn) {
      var b = document.createElement('button'); b.type = 'button'; b.className = cls; b.setAttribute('aria-label', label); b.innerHTML = html;
      b.addEventListener('click', fn); lb.appendChild(b); return b;
    }
    var x = btn('u-lb-x', 'Fermer', X, closeLB);
    if (pics.length > 1) {
      btn('u-lb-p', 'Précédente', PREV, function () { show(idx - 1); });
      btn('u-lb-n', 'Suivante', NEXT, function () { show(idx + 1); });
    }
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target === fig) closeLB(); });
    lbKey = function (e) {
      if (e.key === 'Escape') closeLB();
      else if (pics.length > 1 && e.key === 'ArrowLeft') show(idx - 1);
      else if (pics.length > 1 && e.key === 'ArrowRight') show(idx + 1);
    };
    document.addEventListener('keydown', lbKey);
    show(idx);
    document.body.appendChild(lb);
    document.body.classList.add('u-lb-open');
    requestAnimationFrame(function () { requestAnimationFrame(function () { if (lb) lb.classList.add('in'); }); });
    x.focus();
  }

  function initGallery(g) {
    var stage = $('[data-stage]', g);
    var slides = $$('.u-pdp-slide', g);
    var thumbs = $$('[data-th]', g);
    var cur = $('[data-cur]', g);
    var n = slides.length, i = 0;
    if (!n) return;

    function go(k, fromUser) {
      i = (k + n) % n;
      slides.forEach(function (s, j) { s.classList.toggle('is-active', j === i); });
      thumbs.forEach(function (t, j) {
        var on = j === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      if (cur) cur.textContent = pad(i + 1);
      if (fromUser && thumbs[i] && thumbs[i].scrollIntoView) {
        try { thumbs[i].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduce ? 'auto' : 'smooth' }); } catch (e) {}
      }
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.getAttribute('data-th'), true); }); });
    var pv = $('[data-prev]', g), nx = $('[data-next]', g);
    if (pv) pv.addEventListener('click', function () { go(i - 1, true); });
    if (nx) nx.addEventListener('click', function () { go(i + 1, true); });

    var zoom = $('[data-zoom]', g);
    function zoomNow() {
      var pics = slides.map(function (s) { return s.getAttribute('data-full') || ($('img', s) || {}).src; });
      var img = $('img', slides[i]);
      openLB(pics, i, img ? img.alt : '');
    }
    if (zoom) zoom.addEventListener('click', zoomNow);

    g.setAttribute('tabindex', '-1');
    g.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { go(i - 1, true); }
      else if (e.key === 'ArrowRight') { go(i + 1, true); }
    });

    var sx = 0, sy = 0, dx = 0, drag = false, moved = false;
    stage.addEventListener('pointerdown', function (e) {
      if (e.target.closest('button')) return;
      drag = true; moved = false; sx = e.clientX; sy = e.clientY; dx = 0;
    });
    stage.addEventListener('pointermove', function (e) {
      if (e.pointerType === 'mouse' && !reduce) {
        var r = stage.getBoundingClientRect();
        stage.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
        stage.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
      }
      if (!drag) return;
      dx = e.clientX - sx;
      if (Math.abs(dx) > 8) moved = true;
    });
    function end(e) {
      if (!drag) return;
      drag = false;
      if (e && e.type === 'pointercancel') return;
      if (Math.abs(dx) > 46 && Math.abs((e ? e.clientY : sy) - sy) < Math.abs(dx)) { go(i + (dx < 0 ? 1 : -1), true); }
      else if (!moved && e && e.target && !e.target.closest('button')) { zoomNow(); }
    }
    stage.addEventListener('pointerup', end);
    stage.addEventListener('pointercancel', end);
    stage.addEventListener('pointerleave', function () { drag = false; });
    go(0, false);
  }
  $$('[data-u-gal]').forEach(initGallery);

  /* ---------- pastilles couleur ---------- */
  $$('[data-colors]').forEach(function (box) {
    var label = $('[data-color-name]', box);
    var def = label ? label.textContent : '';
    var sws = $$('.u-pdp-sw', box);
    /* on n'affiche que les couleurs réellement proposées dans le tunnel (étape couleur) */
    var avail = $$('#unit-sales-funnel-step-3 input[type="radio"]').map(function (r) { return norm(r.value); });
    if (avail.length) {
      sws = sws.filter(function (s) {
        var ok = avail.indexOf(norm(s.getAttribute('data-color'))) > -1;
        if (!ok && s.parentNode) s.parentNode.style.display = 'none';
        return ok;
      });
    }
    function txt(sw) { return sw.getAttribute('data-color') + (sw.getAttribute('data-plus') ? ' ' + sw.getAttribute('data-plus') : ''); }
    function sel(sw) {
      sws.forEach(function (s) { s.classList.toggle('is-sel', s === sw); s.setAttribute('aria-pressed', s === sw ? 'true' : 'false'); });
      if (label) label.textContent = sw ? txt(sw) : def;
    }
    sws.forEach(function (sw) {
      sw.setAttribute('aria-pressed', 'false');
      sw.addEventListener('mouseenter', function () { if (label && !box.querySelector('.is-sel')) label.textContent = txt(sw); });
      sw.addEventListener('mouseleave', function () { if (label && !box.querySelector('.is-sel')) label.textContent = def; });
      sw.addEventListener('click', function () { sel(sw); openFunnel(sw.getAttribute('data-color')); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') sel(null); });
    ['unit-sales-funnel-close', 'unit-sales-funnel-close-mobile'].forEach(function (id) {
      var b = document.getElementById(id);
      if (b) b.addEventListener('click', function () { sel(null); });
    });
  });

  /* ---------- barre d'achat flottante ---------- */
  var bar = $('[data-bar]'), buy = $('[data-buy]');
  if (bar && buy && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        var on = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        var b = $('.u-pdp-bar-cta', bar); if (b) b.tabIndex = on ? 0 : -1;
      });
    }, { threshold: 0 });
    io.observe(buy);
  }

  /* ---------- parallaxe des bannières ---------- */
  var pbs = $$('[data-pban-bg]');
  if (pbs.length && !reduce) {
    var tick = false;
    var upd = function () {
      tick = false;
      var vh = window.innerHeight;
      pbs.forEach(function (el) {
        var r = el.parentNode.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        var p = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.transform = 'translate3d(0,' + (p * -34).toFixed(1) + 'px,0) scale(1.08)';
      });
    };
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(upd); } }, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  }
})();